<template>
  <div>
    <List
      url="device_alarms/"
      :title="title"
      titleClass="title"
      :size="size"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :update="updateList"
      :operat="operat"
      :MultipleSel="true"
      :is_admin="is_admin"
      @edit="edit"
      @download="download"
    >
      <div slot="Filter" style="display: block;">
        <div class="item">
          <label>告警等级：</label>
          <el-checkbox-group v-model="level">
            <el-checkbox
              v-for="alarmlevel in alarmlevels.slice(1, 6)"
              :label="alarmlevel.ID"
              :key="alarmlevel.ID"
              :value="alarmlevel.ID"
              >{{ alarmlevel.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="item">
          <label>云平台：</label>
          <el-checkbox-group v-model="cloud">
            <el-checkbox
              v-for="platform in platforms"
              :label="platform"
              :key="platform"
              :value="platform"
            >
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="item">
          <label>设备类型：</label>
          <el-checkbox-group v-model="device_type">
            <el-checkbox
              v-for="equipmenttype in equipmenttypes"
              :label="equipmenttype.ID"
              :key="equipmenttype.ID"
              :value="equipmenttype.ID"
              >{{ equipmenttype.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="item">
          <label>告警状态：</label>
          <el-checkbox-group v-model="alarm_status">
            <el-checkbox
              v-for="status in alarmstatus"
              :label="status.ID"
              :key="status.ID"
              :value="status.ID"
              >{{ status.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="item">
          <label>MAC地址：</label>
          <el-input
            v-model="searchData.mac"
            style="width:160px;margin:0px 35px 0px 0px;"
            placeholder="MAC地址"
          ></el-input>
          <label>告警码：</label>
          <el-input
            v-model="searchData.alarm_code"
            style="width:160px;margin:0px 35px 0px 0px;"
            placeholder="告警码"
          ></el-input>
          <label>版本号：</label>
          <el-input
            v-model="searchData.search"
            style="width:160px;"
            placeholder="版本号"
          ></el-input>
        </div>
        <div class="item">
          <label style="margin:5px 0px;">发生时间：</label>
          <el-date-picker
            style="width:160px;"
            v-model="searchData.begin_time"
            type="date"
            placeholder="开始时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <label style="margin:5px 5px;">—</label>
          <el-date-picker
            style=" margin-right:110px;width:160px;"
            v-model="searchData.end_time"
            type="date"
            placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button @click="search" type="primary">搜索</el-button>
        </div>
      </div>

      <template slot="Fresh">
        <!-- <el-button plain type="info" size="small" @click="size = 'medium'">
          大
        </el-button>
        <el-button plain type="info" size="small" @click="size = 'small'">
          中
        </el-button>
        <el-button plain type="info" size="small" @click="size = 'mini'">
          小
        </el-button> -->
        <div style=" margin-bottom:10px;float: right;vertical-align:middle;">
        <el-button  @click="downloadByPeople()" type="primary" style="margin-right:20px">导出</el-button>
        <el-radio-group
          v-model="size"
          size="small"
        >
          <el-radio-button label="medium">大</el-radio-button>
          <el-radio-button label="small">中</el-radio-button>
          <el-radio-button label="mini">小</el-radio-button>
        </el-radio-group>
          <br/> <label style="margin:5px 5px;font-size:10px;color:red">最多只能导出5000条</label>
        </div>

      </template>
    </List>
    <UpdateBox
      :initForm="updateForm"
      v-if="updateBlock"
      @close="updateClose"
      @update="updateList++"
    ></UpdateBox>
    <DownloadBox
      :macdata="macdata"
      v-if="downloadBlock"
      @close="downloadClose"
      @update="updateList++"
    ></DownloadBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/AlarmRecord/UpdateBox.vue";
import DownloadBox from "../components/AlarmRecord/DownloadBox.vue";
import CsvExportor from 'csv-exportor';

import { alarmlevelsList } from "../components/Index/data.js";
import { alarmstatusList } from "../components/Index/data.js";
import { equipmenttypesList } from "../components/Index/data.js";

import { Alarmlevels } from "../components/Index/data.js";
import { Alarmstatus } from "../components/Index/data.js";
import { Equipmenttypes } from "../components/Index/data.js";

export default {
  components: {
    List,
    UpdateBox,
    DownloadBox
  },
  data() {
    return {
      tanle: [
        { name: "begin_time", label: "告警时间" },
        { name: "levelName", label: "告警等级", status: "alarmLevel" },
        { name: "end_time", label: "解决时间" },
        { name: "alarm_statusName", label: "状态", status: "alarmStatus" },
        { name: "cloud", label: "云平台" },
        { name: "device_typeName", label: "设备类型" },
        { name: "firmware_version", label: "版本号" },
        { name: "mac", label: "MAC地址" },
        { name: "trace_id", label: "跟踪ID" },
        { name: "alarm_name", label: "告警名称" },
        { name: "alarm_code", label: "错误码" },
        { name: "alarm_log", label: "事件描述", status: "alarmEvent" },
        { name: "alarm_count", label: "次数" },
        { name: "first_time", label: "首次发生时间" },
        { name: "confirm_user", label: "操作人" }
      ],
      searchData: {
        level: "",
        device_type: "",
        begin_time: "",
        end_time: "",
        cloud: "",
        alarm_status: "",
        mac: "",
        alarm_code: "",
        search: ""
      },
      level: [],
      device_type: [],
      cloud: [],
      alarm_status: [],
      platforms: ["ucloud", "ecloud", "scloud", "sacloud", "t-healthcare", "test_kyy", "dev_sh", "dev_hz", "jcloud", "ccloud", "aucloud", "azcloud", "rucloud", "discreet", "discreet2025", "ecloud-tis", "dev", "test", "test84", "test_hz", "test_hager"],
      operat: [
        {
          text: "Edit",
          eventName: "edit"
        },
         {
          text: "Download",
          eventName: "download"
        }
      ],
      updateList: 0,
      alarmlevels: alarmlevelsList,
      alarmstatus: alarmstatusList,
      equipmenttypes: equipmenttypesList,
      title: "告警记录列表",
      size: "small",
      updateBlock: false,
     downloadBlock: false,
      updateForm: {},
      is_admin: false,
      macdata:""
    };
  },
  mounted() {
    this.searchData.begin_time = this.changeToday(
      new Date()
    );
    this.is_admin = JSON.parse(localStorage.getItem("is_admin"));
    this.searchData.end_time = this.changeToday(new Date());
    // window.setInterval(() => { setTimeout(this.search(), 0); }, 120000);  // 自动刷新数据
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        if (data[i].end_time) {
          data[i].end_time = this.changeDate(data[i].end_time);
        }
        if (data[i].first_time) {
          data[i].first_time = this.changeDate(data[i].first_time);
        }
        if (data[i].begin_time) {
          data[i].begin_time = this.changeDate(data[i].begin_time);
        }
        data[i].levelName = Alarmlevels[data[i].level];
        data[i].alarm_statusName = Alarmstatus[data[i].alarm_status];
        data[i].device_typeName = Equipmenttypes[data[i].device_type];
      }
      return data;
    },
    edit(val) {
      this.updateBlock = true;
      this.updateForm = Object.assign({}, val);
    },
    download(val) {
       this.downloadBlock = true;
      this.updateForm = Object.assign({}, val);
       this.macdata=val;
    },
    updateClose() {
      this.updateBlock = false;
    },
    downloadClose() {
      this.downloadBlock = false;
    },
    search() {
      this.searchData.level = this.level.join(",");
      this.searchData.device_type = this.device_type.join(",");
      this.searchData.alarm_status = this.alarm_status.join(",");
      this.searchData.cloud = this.cloud.join(",");
      this.updateList++;
    },
    changeToday(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      return nowYear + "-" + nowMonth + "-" + nowDay;
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    //添加导出函数
    downloadByPeople(){
      let formData=[];
      formData=this.searchData;
      this.$http.get("device_alarms/",{
        level:  formData.level,
        device_type:  formData.device_type,
        begin_time:  formData.begin_time,
        end_time:  formData.end_time,
        cloud:  formData.cloud,
        alarm_status:  formData.alarm_status,
        mac:  formData.mac,
        alarm_code: formData.alarm_code,
        search: formData.search
      },(data)=>{

       let heads=['告警时间','告警等级','解决时间','状态','云平台','设备类型','版本号','MAC地址','跟踪ID','告警名称','错误码','事件描述','次数','首次发生时间','操作人'];
       let csvData=[];
       let importData=data.data.results;
       let importDataLength;
       importDataLength=importData.length>5000 ? 5000 :importData.length;
       for(let i=0;i<importDataLength;i++){
         let obj=importData[i];
        switch(obj.level){
          case 0:
            obj.level="未分类";
            break;
          case 1:
            obj.level="灾难";
            break;
            case 2:
            obj.level="严重";
            break;
            case 3:
            obj.level="一般";
            break;
            case 4:
            obj.level="警告";
            break;
             case 5:
            obj.level="信息";
            break;
        }
        switch(obj.alarm_status){
          case 0:
            obj.alarm_status="未处理";
            break;
          case 1:
            obj.alarm_status="处理中";
            break;
          case 2:
            obj.alarm_status="已解决";
            break;

        }
        switch(obj.device_type){
          case 0:
            obj.device_type="APP";
            break;
          case 1:
             obj.device_type="门口机";
            break;
           case 2:
             obj.device_type="室内机";
            break;

        }

        let begin_time=[];
        begin_time=obj.begin_time.split("T");
        let first_time=[];
        first_time=obj.first_time.split("T");
        if(obj.end_time===null){
         csvData.push({
          [heads[0]]: begin_time[0]+'\n'+begin_time[1],
					[heads[1]]: obj.level,
          [heads[2]]: obj.end_time,
          [heads[3]]: obj.alarm_status,
          [heads[4]]: obj.cloud,
          [heads[5]]: obj.device_type,
          [heads[6]]: obj.firmware_version,
          [heads[7]]: obj.mac,
          [heads[8]]: obj.trace_id,
          [heads[9]]: obj.alarm_name,
          [heads[10]]: obj.alarm_code,
          [heads[11]]: obj.alarm_log,
          [heads[12]]: obj.alarm_count,
          [heads[13]]: first_time[0]+'\n'+first_time[1],
          [heads[14]]: obj.confirm_user,
         })
        }else{
           let end_time=[];
           end_time=obj.end_time.split("T");

           csvData.push({
          [heads[0]]: begin_time[0]+'\n'+begin_time[1],
					[heads[1]]: obj.level,
          [heads[2]]: end_time[0]+'\n'+end_time[1],
          [heads[3]]: obj.alarm_status,
          [heads[4]]: obj.cloud,
          [heads[5]]: obj.device_type,
          [heads[6]]: obj.firmware_version,
          [heads[7]]: obj.mac,
          [heads[8]]: obj.trace_id,
          [heads[9]]: obj.alarm_name,
          [heads[10]]: obj.alarm_code,
          [heads[11]]: obj.alarm_log,
          [heads[12]]: obj.alarm_count,
          [heads[13]]: first_time[0]+'\n'+first_time[1],
          [heads[14]]: obj.confirm_user,
           })
        }
       }

       	CsvExportor.downloadCsv(
				csvData,
				{ header: heads },
				'告警记录.csv'
			)

      });


    },
  }
};
</script>
<style>
.item {
  display: flex;
  margin: 10px 0px;
  margin-right: 15px;
  line-height: 27px;
}
</style>
